import { render } from "./FilterSectionTitle.vue?vue&type=template&id=5495b969&scoped=true"
import script from "./FilterSectionTitle.vue?vue&type=script&lang=js"
export * from "./FilterSectionTitle.vue?vue&type=script&lang=js"

import "./FilterSectionTitle.vue?vue&type=style&index=0&id=5495b969&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5495b969"]])

export default __exports__